import React, { useState } from 'react'
import { Box, Avatar, Menu, MenuItem, Typography } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'

interface UserProfileProps {
  auth: {
    isAuthenticated: boolean
    user?: {
      profile: {
        name?: string
        given_name?: string
        family_name?: string
        avatar?: string
      }
    } | null
  }
  onLogout: () => void
}

export default function UserProfile ({ auth, onLogout }: UserProfileProps): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  return (
    <>
      {auth.isAuthenticated && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            alt={auth.user?.profile.name}
            src={auth.user?.profile.avatar ?? ''}
            sx={{ width: 40, height: 40, cursor: 'pointer' }}
            onClick={handleClick}
            data-testid='user-avatar-clickable'
          />
        </Box>
      )}

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          sx: {
            background: '#000'
          }
        }}
        PaperProps={{
          sx: { width: 137, marginTop: '12px', position: 'fixed', left: 'auto !important', right: 0 }
        }}
      >
        <MenuItem
          sx={{
            height: 48,
            '&:hover': {
              width: '100%',
              backgroundColor: '#666565ff'
            }
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <Avatar
              src={auth.user?.profile.avatar ?? ''}
              sx={{ width: 25, height: 25 }}
            />
            <Typography variant="body1" sx={{ fontFamily: 'Honeywell Sans Web' }}>
              {`Hi, ${auth.user?.profile.name?.split(' ')[0] ?? ''}`}
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem sx={{
          height: 48,
          '&:hover': {
            width: '100%',
            backgroundColor: '#666565ff'
          }
        }}
          onClick={() => {
            handleClose()
            onLogout()
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <LogoutIcon />
            <Typography sx={{ fontFamily: 'Honeywell Sans Web' }}>Sign Out</Typography>
          </Box>
        </MenuItem>
      </Menu>
    </>
  )
}
